{
  "#ARTIKELINFO": {
    "DIALOGS": {
      "ADD_FAVORITE_ITEM": {
        "ADD": "Hinzufügen",
        "CANCEL": "Abbrechen",
        "CREATE_LIST_ACTION": "Neue Liste anlegen",
        "SUBTITLE": "Um den Artikel zu ihren Favoriten hinzuzufügen, wählen Sie ein bestehende Favoriten-Liste aus.",
        "TITLE": "Favoriten-Liste auswählen"
      },
      "ADD_FAVORITE_LIST": {
        "ADD": "Liste erstellen",
        "CANCEL": "Abbrechen",
        "NAME_PLACEHOLDER": "Name",
        "TITLE": "Favoriten-Liste anlegen"
      },
      "BEWEGUNGEN": {
        "COLUMNS": {
          "AMOUNT": "Menge",
          "DATA": "Daten",
          "OPEN": "Offen"
        },
        "EMPTY": "Keine Bewegungen gefunden",
        "TABS": {
          "ORDERS": "Aufträge",
          "PICKING_SLIPS": "Kommissionierscheine",
          "PURCHASE_ORDERS": "Bestellungen"
        },
        "TITLE": "Bewegungen {{stock}}"
      },
      "SAVE_EXPORT": {
        "CANCEL": "Abbrechen",
        "EMAIL_PLACEHOLDER": "E-Mail (Empfänger)",
        "EXPORT_DESC": "Wenn Sie die Liste als CSV-Datei per E-Mail versenden wollen, tragen Sie im Feld bitte die E-Mail Adresse des Empfängers ein",
        "EXPORT_TITLE": "Exportieren",
        "SAVE": "Speichern",
        "SAVE_DESC": "Wählen Sie die Liste aus in der die gescannten Artikel gespeichert werden sollen",
        "SAVE_NEW_LIST": "Neue Favoritenliste erstellen",
        "SAVE_PLACEHOLDER": "Keine (Nicht Speichern)",
        "SAVE_TITLE": "Speichern",
        "SUCCESS": "Erfolgreich abgeschlossen!",
        "TITLE": "Speichern & Exportieren"
      }
    },
    "MENU": {
      "FAVORITES": "Favoriten",
      "SCAN_LIST": "Scan-Liste",
      "SEARCH": "Suche"
    },
    "MESSAGES": {
      "ADD_ITEM_SUCCESS": {
        "MESSAGE": "Der Artikel \"{{item}}\" wurde erfolgreich zur Liste \"{{list}}\" hinzugefügt",
        "TITLE": "Artikel zur Liste hinzugefügt"
      },
      "CREATE_LIST_SUCCESS": {
        "MESSAGE": "Die Favoriten-Liste {{name}} wurde erfolgreich angelegt.",
        "TITLE": "Liste erstellt"
      },
      "REMOVE_LIST": {
        "QUESTION": "Sind Sie sicher, dass die Liste \"{{name}}\" unwiderruflich gelöscht werden soll?",
        "TITLE": "Liste löschen"
      },
      "REMOVE_LIST_SUCCESS": {
        "MESSAGE": "Die Liste {{name}} wurde gelöscht!",
        "TITLE": "Löschen erfolgreich"
      }
    },
    "PAGES": {
      "DETAIL": {
        "ACTIONS": {
          "ADD_FAVORITE": "Zu Favoriten hinzufügen",
          "ESL_FLASH": "ESL Blinken",
          "SCAN": "Scannen",
          "TITLE": "Aktions"
        },
        "ARTBEZ1": "Artikelbezeichnung 1",
        "ARTBEZ2": "Artikelbezeichnung 2",
        "ARTBEZ3": "Artikelbezeichnung 3",
        "ARTBEZ4": "Artikelbezeichnung 4",
        "ARTBEZ5": "Artikelbezeichnung 5",
        "COPY_ERROR": "Kopieren fehlgeschlagen",
        "COPY_SUCCESS": "Artikelnummer kopiert",
        "HEADER": {
          "AVAILABLE_STOCK": "Verfügbar / Lagerstand",
          "COPY_ITEM_NUMBER": "Artikelnummer kopieren",
          "EAN": "EAN",
          "MATCHCODE": "Matchcode",
          "NOT_SPECIFIED": "nicht angegeben",
          "NO_VALUE": "keine Angabe",
          "PRICE": "Preis",
          "PRICE_INCLUSIVE": "inkl. / {{unit}}",
          "TOTAL_STOCK": "Gesamt ({{count}} Lager)"
        },
        "ITEM_NUMBER": "Artikelnummer",
        "MEDIA": {
          "NO_IMAGE": "Kein Bild"
        },
        "OPEN_ORDERS": {
          "OPEN_AMOUNT": "Offene Bestellmenge",
          "STOCK": "Lager",
          "TITLE": "Offene Bestellungen"
        },
        "PRICES": {
          "AMOUNT": "Staffel",
          "PER": "Per",
          "PRICE": "Inkl. Preis",
          "TITLE": "Preise",
          "UNIT": "Einheit"
        },
        "STOCK": {
          "AMOUNT": "Lagermenge",
          "DISPO": "Dispomenge",
          "MAIN": "Hauptlagerplatz",
          "NEXT_DELIVERY": "Nächste Lieferung: {{date}}",
          "ORDER_AMOUNT": "Gesamte Bestellmenge:",
          "STOCK": "Lager",
          "TITLE": "Lagerstände",
          "TOTAL_DISPO": "Dispomenge gesamt"
        },
        "STOCK_LOCATIONS": {
          "TITLE": "Lagerplätze"
        },
        "SUPPLIERS": {
          "MAIN": "Hauptlieferant",
          "MIN_ORDER_AMOUNT": "Min. Bestellmenge",
          "NO_MIN": "keine Angabe",
          "SUPPLIER_ITEM_NUMBER": "Lief-Art.-Nr",
          "SUPPLIER_NUMBER": "Lief.-Nr",
          "TITLE": "Lieferanten",
          "UNIT": "Einheit"
        },
        "UMSATZABFRAGE": {
          "ALL_BRANCHES": "Alle",
          "BRANCH": "Filiale",
          "FROM": "Von",
          "MISSING_DATE_RANGE": "Bitte Von- und Bis-Datum eingeben!",
          "MONTH": "Monat",
          "NO_RESULTS": "Es konnten keine Umsätze gefunden werden",
          "PREV_YEAR": "Vorjahr",
          "QTY": "Menge",
          "START": "Abfrage starten",
          "SUM": "SUMME",
          "TABS": {
            "PURCHASE": "EK",
            "SALES_AMOUNT": "VKM",
            "SALES_MARGIN": "VKDB%",
            "SALES_REVENUE": "VKerl"
          },
          "TITLE": "Umsatzabfrage",
          "TO": "Bis",
          "VALUE": "Betrag"
        },
        "UNITS": {
          "FACTOR": "Faktor",
          "TITLE": "Einheiten",
          "UNIT": "Einheit",
          "WEIGHT": "Gewicht"
        },
        "VKFORG": {
          "LISTUNG": "Listung",
          "VKFORG": "Verkaufsorganisation/Filiale"
        }
      },
      "FAVORITE": {
        "COMMANDS": {
          "DELETE_LIST": "Liste löschen",
          "EXPORT_LIST": "Liste exportieren"
        },
        "EMPTY": "Keine Artikel in der Liste",
        "ITEM_COUNT": "{{count}} Artikel",
        "REMOVE_ITEM": {
          "QUESTION": "Sind Sie sicher, dass der Artikel aus der Favoriten-Liste entfernt werden soll?",
          "TITLE": "Artikel löschen"
        }
      },
      "FAVORITE_LISTS": {
        "COMMANDS": {
          "NEW_LIST": "Neue Liste"
        },
        "DEFAULT_LIST_NAME": "Artikelsuche",
        "EMPTY": "Sie haben noch keine Favoriten-Liste erstellt",
        "NO_SEARCH_RESULT": "Es konnte keine Liste die mit \"{{search}}\" beginnt gefunden werden",
        "SEARCH_PLACEHOLDER": "Listen durchsuchen",
        "TITLE": "Favoriten"
      },
      "LIST": {
        "ACTIONS_TITLE": "Artikelsuche",
        "EMPTY": "Bitte scannen Sie einen Artikel oder nutzen Sie die Artikelsuche.",
        "EMPTY_TITLE": "Kein Artikel ausgewählt",
        "MANAGE_SEARCH_HISTORY": "Suchverlauf verwalten",
        "SCAN": "Scannen",
        "SEARCH": "Suchen",
        "SEARCH_HISTORY": "Suchverlauf",
        "SEARCH_PLACEHOLDER": "Artikel suchen",
        "SEARCH_RESULTS": "Suchergebnisse für \"{{term}}\""
      },
      "SCAN_LIST": {
        "CANCEL": "Abbrechen",
        "EMPTY_DESCRIPTION": "Bitte scannen Sie einen oder mehrere Artikel mithilfe des Buttons unterhalb oder nutzen Sie die Aktion in der Titelleiste. Sollten Sie ein Zebra-Gerät mit integriertem Hardware-Scanner besitzen, können Scans auch mit diesem durchgeführt werden.",
        "EMPTY_TITLE": "Es wurden noch keine Artikel gescannt",
        "EXPORT_SAVE": "Exportieren/Speichern",
        "SCAN": "Scannen",
        "START_SCAN": "Scan starten",
        "SUBTITLE": "Bitte scannen Sie Artikel. Sie können die gescannten Artikel im Anschluss als CSV herunterladen und/oder per E-Mail versenden.",
        "TITLE": "Scan-Liste"
      },
      "SEARCH_HISTORY": {
        "EMPTY": "Auf diesem Gerät wurde noch kein Suchverlauf gespeichert.",
        "REMOVED": {
          "MESSAGE": "Der Suchbegriff wurde aus dem Verlauf entfernt",
          "TITLE": "Suchbegriff entfernt"
        },
        "SAVED_TERMS": "Gespeicherte Suchbegriffe",
        "TITLE": "Suchverlauf"
      }
    },
    "TITLE": "Artikel-Info"
  }
}
